export const LOCAL_STORAGE_KEY_USER = 'LOCAL_STORAGE_KEY_USER'
